export function getFileKeyFromSignedUrl(signedUrl: string): string {
  try {
    return (
      new URL(signedUrl).pathname.split('/lighthouz-uploads-staging/')[1] || ''
    );
  } catch (error) {
    console.error('Error extracting file key:', error);
    return '';
  }
}
